import { v4 as uuid } from 'uuid';
import cloneDeep from 'clone-deep';
import { ExtendedQualQuestion, ID } from 'types';

/**
 * Creates a default lot question based on a reference question
 *
 * @param lotId The ID of the lot to associate with the question
 * @param refQuestion The reference question to base the new question on
 * @returns A new lot question with default values
 */
export const defaultLotQuestion = (
  lotId: ID,
  refQuestion: ExtendedQualQuestion
): ExtendedQualQuestion => {
  const questionId = `new-${uuid()}`;

  const qqaos = refQuestion.qual_question_answer_options.map(originalQqao => {
    const qqao = cloneDeep(originalQqao);

    // Create default weight for this answer option
    const aoWeight = qqao.answer_option_weight ? {
      ...qqao.answer_option_weight,
      id: `new-${uuid()}`
    } : null;

    return {
      ...qqao,
      answer_option_weight: aoWeight,
      answer_option_weight_id: aoWeight ? aoWeight.id : null,
      qual_question_id: questionId,
    };
  });

  return {
    answer_options: [...refQuestion.answer_options],
    character_limit: refQuestion.character_limit,
    group_id: refQuestion.group_id,
    id: questionId,
    is_applied: !!refQuestion.is_applied,
    is_required: refQuestion.is_required,
    order_index: refQuestion.order_index,
    qual_question_answer_options: qqaos,
    question_type: refQuestion.question_type,

    // Extended properties
    questionable_id: lotId,
    questionable_parent_id: refQuestion.questionable_parent_id,
    questionable_type: 'Lot',
    text: refQuestion.text,
    visible: !!refQuestion.visible,
  };
};
